import { Component, esc } from '../core/component.js';
import { api, ApiError } from '../core/api.js';
import { icon } from '../core/icons.js';
import { t } from '../core/i18n.js';

export class NotificationsView extends Component {
  constructor() {
    super();
    this.state = { items: null, error: null };
  }

  template() {
    const items = this.state.items;
    return `
      <section class="stack">
        <div class="row-between">
          <h2>${esc(t('notifications.title'))}</h2>
          <button class="btn btn-ghost" data-action="mark-all">${icon('check', { size: 'sm' })}<span>${esc(t('notifications.mark_all_read'))}</span></button>
        </div>
        ${this.state.error ? `<div class="error-banner">${esc(this.state.error)}</div>` : ''}
        ${items === null
          ? `<div class="muted">${esc(t('common.loading'))}</div>`
          : items.length === 0
            ? `<div class="empty">${esc(t('notifications.empty'))}</div>`
            : `<div class="notif-list">${items.map((n) => this._row(n)).join('')}</div>`}
      </section>
    `;
  }

  _row(n) {
    const isUnread = !n.read_at;
    const link = this._linkFor(n);
    return `
      <div class="notif-row ${isUnread ? 'unread' : ''}" data-id="${esc(n.id)}">
        <div class="row-between">
          <div class="notif-title">${esc(n.title)}</div>
          <span class="notif-time">${esc(n.created_at || '')}</span>
        </div>
        <div class="muted">${esc(n.body || '')}</div>
        ${link ? `<a href="${esc(link)}" class="btn btn-ghost btn-sm" style="align-self:flex-start">${esc(t('common.open'))}</a>` : ''}
      </div>
    `;
  }

  _linkFor(n) {
    const data = n.data_json || {};
    if (data.maintenance_id) return `#/maintenance/${data.maintenance_id}`;
    if (data.inquiry_id) return `#/inquiries/${data.inquiry_id}`;
    if (data.tenancy_id) return `#/tenancies/${data.tenancy_id}`;
    return null;
  }

  mount() {
    this.el.querySelector('[data-action="mark-all"]').addEventListener('click', () => this._markAll());
    if (this.state.items === null) this._load();
  }

  async _load() {
    try {
      const res = await api.get('/notifications');
      const items = res.data || [];
      this.setState({ items });
      // Auto-mark items as read once viewed (sequential to keep traffic low).
      for (const n of items) {
        if (!n.read_at) { try { await api.post(`/notifications/${n.id}/read`); } catch (_) {} }
      }
    } catch (e) {
      this.setState({ error: e instanceof ApiError ? e.message : t('notifications.title') });
    }
  }

  async _markAll() {
    try { await api.post('/notifications/read-all'); this.setState({ items: null }); this._load(); }
    catch (_) {}
  }
}
